import React from 'react'
import LoginAndRegisterContent from './components/login/LoginAndRegisterContent'

const LoginScreen = () => <LoginAndRegisterContent type='LOGIN' />

export default LoginScreen
